import { SelectField } from "../../components";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

function CancellationReason() {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const options = [
    { label: "Sold Furniture", value: "Sold Furniture" },
    { label: "Changed Your Mind", value: "Changed Your Mind" },
    { label: "Moved Out of Area", value: "Moved Out of Area" },
    { label: "Claim Outcome", value: "Claim Outcome" },
    { label: "Returned Merchandise", value: "Returned Merchandise" },
    { label: "Cancelled Order", value: "Cancelled Order" },
  ];

  return (
    <div className="space-y-4">
      <SelectField
        control={control}
        name="cancellation_reason"
        label="Plan Cancellation Reason"
        required
        options={options}
        placeholder="Select Reason"
      />
      <div className="bg-[#F8F8F8] p-4 rounded-lg border border-[#EDEDED]">
        <p className="text-gray-600 text-sm italic">
          {t(
            "We understand that needs can change, and we're here to help. Once submitted, your request will be processed in accordance with the plan's cancellation turn."
          )}
        </p>
      </div>
    </div>
  );
}

export default CancellationReason;
